<template>
    <component
        :is="product.slug ? 'a' : 'div'"
        v-bind="linkAttrs"
        :aria-label="title"
        class="flex h-full w-full items-stretch overflow-hidden rounded-xl border-2 border-stack-text no-underline shadow-md"
        @click="onClick"
    >
        <div class="h-full w-2/5 flex-none bg-stack-text">
            <img
                v-if="imageUrl"
                :src="imageUrl"
                :alt="imageAlt"
                class="h-full w-full object-cover"
            />
            <ProductPlaceholderImage v-else :label="title" />
        </div>
        <div
            class="flex min-w-0 flex-1 flex-col justify-center gap-1 px-4 py-2"
        >
            <span
                class="line-clamp-2 text-sm font-semibold leading-5 text-stack-text"
            >
                {{ title }}
            </span>
            <div class="flex flex-wrap items-baseline gap-2">
                <ProductPriceViewer
                    v-slot="{ isOffer }"
                    :price="resolvedReference.price"
                    :price-offer="resolvedReference.priceOffer"
                >
                    <span class="text-lg font-bold text-stack-primary">
                        {{ formatCurrency(displayPrice(isOffer)) }}
                    </span>
                    <span
                        v-if="isOffer"
                        class="text-xs line-through text-stack-text opacity-60"
                    >
                        {{ formatCurrency(resolvedReference.price) }}
                    </span>
                </ProductPriceViewer>
            </div>
        </div>
    </component>
</template>

<script>
import { formatCurrency } from "@/common/lib/money";

import ProductPlaceholderImage from "@/components/catalog/ProductPlaceholderImage.vue";
import ProductPriceViewer from "@/components/catalog/ProductPriceViewer.vue";

export default {
    name: "ProductItem2",
    components: { ProductPriceViewer, ProductPlaceholderImage },
    props: {
        product: { type: Object, required: true },
        openInNewTab: { type: Boolean, default: false },
        previewOnly: { type: Boolean, default: false }
    },
    computed: {
        resolvedReference() {
            return this.product.references?.[0] ?? {};
        },
        title() {
            return this.product.name;
        },
        imageUrl() {
            return this.resolvedReference.images?.[0]?.url;
        },
        imageAlt() {
            return this.resolvedReference.images?.[0]?.alt || this.title;
        },
        href() {
            return `/${this.product.slug}`;
        },
        target() {
            return this.openInNewTab ? "_blank" : undefined;
        },
        rel() {
            return this.openInNewTab ? "noopener noreferrer" : undefined;
        },
        linkAttrs() {
            return this.product.slug
                ? {
                      href: this.href,
                      target: this.target,
                      rel: this.rel
                  }
                : {};
        }
    },
    methods: {
        formatCurrency,
        displayPrice(isOffer) {
            return isOffer
                ? this.resolvedReference.priceOffer
                : this.resolvedReference.price;
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
